import Header from './components/Header/Header';
import './App.css';
import Cards from './components/Cards/Cards';
import Questions from './components/Questions/Questions';

function App() {
  return (
    <div className="App">
      <Header></Header>
      <Cards></Cards>
      <Questions></Questions>
    </div>
  );
}

export default App;
